// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"a734699d","159":"1899ec6f","488":"1b9a64fc","570":"f6f0a1f0","575":"1a618792","595":"8e00c848","748":"104da2b5","884":"441f5797"}[chunkId] + ".chunk.js";
};